import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatOptionModule, provideNativeDateAdapter } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule, MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';

import { SharedModule } from '../shared/shared.module';
import { MonthPickerComponent } from '../shared/month/month-picker.component';
import { DashboardCardComponent } from '../shared/dashboard/dashboard-card.component';

import { InvestmentsRoutingModule } from './investments-routing.module';
import { InvestmentsComponent } from './investments.component';
import { CompaniesComponent } from './companies/companies.component';
import { CompanyCreateComponent } from './companies/create/create.component';
import { CompanyModifyComponent } from './companies/modify/modify.component';
import { CompaniesPipe } from './companies/companies.pipe';
import { StocksComponent } from './stocks/stocks.component';
import { StockCreateComponent } from './stocks/create/create.component';
import { StockModifyComponent } from './stocks/modify/modify.component';
import { CryptosComponent } from './cryptos/cryptos.component';
import { CryptoCreateComponent } from './cryptos/create/create.component';
import { CryptoModifyComponent } from './cryptos/modify/modify.component';
import { ReitsComponent } from './reits/reits.component';
import { ReitCreateComponent } from './reits/create/create.component';
import { ReitModifyComponent } from './reits/modify/modify.component';
import { DividendsComponent } from './dividends/dividends.component';
import { DividendCreateComponent } from './dividends/create/create.component';
import { DividendModifyComponent } from './dividends/modify/modify.component';
import { SharesComponent } from './shares/shares.component';
import { ShareCreateComponent } from './shares/create/create.component';
import { ShareModifyComponent } from './shares/modify/modify.component';
import { FixedComponent } from './fixed/fixed.component';
import { FixedCreateComponent } from './fixed/create/create.component';
import { FixedModifyComponent } from './fixed/modify/modify.component';
import { GenialLayoutService } from './statement-reader/genial-layout.service';
import { StatementReaderComponent } from './statement-reader/statement-reader.component';


@NgModule({
  declarations: [
    InvestmentsComponent,
    CompaniesComponent,
    CompanyCreateComponent,
    CompanyModifyComponent,
    SharesComponent,
    ShareCreateComponent,
    ShareModifyComponent,    
    StocksComponent,
    StockCreateComponent,
    StockModifyComponent,
    CryptosComponent,
    CryptoCreateComponent,
    CryptoModifyComponent,
    ReitsComponent,
    ReitCreateComponent,
    ReitModifyComponent,
    DividendsComponent,
    DividendCreateComponent,
    DividendModifyComponent,
    FixedComponent,
    FixedCreateComponent,
    FixedModifyComponent,
    
    StatementReaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,

    SharedModule,
    
    InvestmentsRoutingModule,

    CompaniesPipe,

    MatCardModule, 
    MatInputModule, 
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatDialogModule,
    MatDividerModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatListModule,
    MatOptionModule,
    MatRadioModule,
    MatRadioButton,
    MatRadioGroup,
    MatCheckboxModule,
    MatSelectModule,
    MatDatepickerModule, 
    MatLabel,
    MatBadgeModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatExpansionModule,

    BaseChartDirective,
    MonthPickerComponent,
    DashboardCardComponent
    
  ],
  providers:[
    provideNativeDateAdapter(),
    provideCharts(withDefaultRegisterables()),
    GenialLayoutService
  ],
  exports:[
  ]
})
export class InvestmentsModule { }

